export const SET_INDEX_LIBRARY = "SET_INDEX_LIBRARY";
export const SET_INDEX_DATA = "SET_INDEX_DATA";
export const INSERT_INDEX_DATA = "INSERT_INDEX_DATA";
export const CLEAR_INDEX_DATA = "CLEAR_INDEX_DATA";
export const REMOVE_INDEX_DATA = "REMOVE_INDEX_DATA";